<template>
  <div>
    <div data-v-c4709cfa="" data-v-249f9abc="" class="main-header">
      <div data-v-c4709cfa="" class="banner">
        <div data-v-c4709cfa="" class="bg">
          <div data-v-c4709cfa="" class="button-inner">
            <div data-v-c4709cfa="" class="button-item"></div>
            <div data-v-c4709cfa="" class="button-item current"></div>
          </div>
          <div data-v-c4709cfa="" class="item pic1 transition-box" style=""></div>
          <div data-v-c4709cfa="" class="item pic2 transition-box" style="display: none;"></div>
        </div>
      </div>
      <div data-v-c4709cfa="" class="link-button-inner">
        <dl v-for="(item,i) in business" :key="i" data-v-c4709cfa="" class="round-button" @click="navTo(item.href)">
          <dd data-v-c4709cfa="" :class="[item.ics]"></dd>
          <dt data-v-c4709cfa="">{{item.text}}</dt>
        </dl>
      </div>
    </div>
    <div data-v-249f9abc="" class="wrapper clearfix">
      <div data-v-249f9abc="" class="content clearfix">
        <div data-v-33098582="" class="stage">
          <div data-v-33098582="" class="clearfix" style="padding-top: 10px;">
            <div data-v-33098582="" class="zhinan">
              <div data-v-33098582="" class="message-box">
                <div data-v-33098582="" class="title">
                  <h4 data-v-33098582="">
                    服务指南
                  </h4> 
                  <!-- <span data-v-33098582=""><span data-v-33098582="" class="more">
                      更多
                    </span> <span data-v-33098582=""><i data-v-33098582="" class="el-icon-arrow-right"></i></span></span> -->
                </div>
                <ul data-v-33098582="" style="color:#000" class="list" >
                  <li data-v-33098582="" @click="linkTo('/service_guide','0')">
                    营业网点查询
                  </li>
                  <li data-v-33098582="" @click="linkTo('/service_guide','2')">
                      水价标准
                    </li>
                  <li data-v-33098582="" @click="linkTo('/service_guide','3')">
                     政策法规
                    </li>
                  <li data-v-33098582="" @click="linkTo('/service_guide','4')">
                    业务办理指南
                    </li>
                </ul>
              </div>
            </div>
            <div data-v-33098582="" class="news">
              <div data-v-33098582="" class="message-box">
                <div data-v-33098582="" class="title">
                  <h4 data-v-33098582="">
                    工程公示
                  </h4>
                </div>
                <ul data-v-33098582="" class="list" v-if="waterExcellent1.length">
                  <li data-v-33098582="" v-for="(item,index) in waterExcellent1" :key="index">{{item.compoundName}}工程公示</li>
                </ul>
                <el-empty v-else></el-empty>
              </div>
            </div>
            <business-aside />
          </div>
        </div>
      </div>
    </div>
    <dialog-wechat @close="dialogVisible=false" :show="dialogVisible"></dialog-wechat>
  </div>
</template>
<script>
import businessAside from '../components/aside'
import dialogWechat from '../components/dialogWechat'
// import http from "../http";
// 引入http
import http from "../http/index";
// const BASE_PATH = window.location.href.split('#')[0]
export default {
  data() {
    return {
      dialogVisible:false,
      business: [
        {
          text: '查交水费',
          ics: ' h-waterfee',
          href: '#/chajiaoshuifei',
          
        },
        {
          text: '业务办理',
          ics: 'h-bid',
          href:'#/yewubanli',
        },
        // {
        //   text: '抗疫专区',
        //   ics: 'wscl',
        //   href: '',
        // },
        {
          text: '业务进度查询',
          ics: 'h-jd',
          href: '#/yewujinduchaxun',
        },
        {
          text: '营业厅业务预约',
          ics: 'el-icon-school',
          href: '#/yingyetingyewuyuyue',
        },
        {
          text: '一键报修',
          ics: 'h-repair',
          href:'#/yijianbaoxiu'
          // href: BASE_PATH + '#' + '/repair',
        },
        {
          text: '客户中心',
          ics: 'h-user',
          href: '#/kehuzhongxin',
        },
        {
          text: '停水信息',
          ics: 'h-ysgg',
          href: 'home.html#/announcement',
        },
      ],
      waterExcellent:[]
    }
  },
  methods: {
    linkTo(href,param){
      if(href){
        if(param){
          href+='/'+param
        }
        this.$router.push(href)
      }else{
        this.dialogVisible=true
      }
    },
    navTo(href,index) {
      console.log('navTo')
      if(href){
        this.$emit('getVisited', index)
        window.location.href = href
        return
      }
      this.dialogVisible=true

      
    },

    //
    async getExcellent(){
      try {
        const res = await http.getExcellent();
        console.log("工程", res);
        this.waterExcellent = res.sort(this.SortDate("createtime",false))
      } catch (ex) {
        console.log(ex);
      }
    },

    // 按时间进行排序算法
    SortDate(time,type){
      //createtime
      return function (a,b){
        let value1 = a[time]
        let value2 = b[time]
        if(type){
          //升序排序
          return Date.parse(value1) - Date.parse(value2)
        }else{
          //降序
          return Date.parse(value2) - Date.parse(value1)
        }
      }
    },

  },
  computed:{
    waterExcellent1(){
      return this.waterExcellent.slice(0,6)
    }
  },
  components: {
    businessAside,
    dialogWechat
  },
  mounted() {
    this.getExcellent()
  }
}
</script>